import { SearchOperationBuilder, SearchParam } from 'wherecomposer/dist/SearchParam';
import { ConditionCreator } from 'wherecomposer/dist/ConditionCreator';
import { getClosingPeriodPage } from '../graphql/financialPeriod';
import { Auth, API, graphqlOperation, Amplify } from 'aws-amplify';

let financialPeriodAppSyncUrl = process.env.REACT_APP_FINANCIAL_PERIOD_APPSYNC_URL;
let financialPeriodApiKey = process.env.REACT_APP_FINANCIAL_PERIOD_API_KEY;

const getClosingPeriod = async (locationGroupGuid) => {
    let languageCode = localStorage.getItem("languageCode");

    try {
        let searchParam = [];
        let objSearchParam = new SearchParam();
        objSearchParam.searchParamCreate("AgencyGuid", "guid", locationGroupGuid, SearchOperationBuilder.create(true, false, false));
        searchParam.push(objSearchParam);


        let objCreator = new ConditionCreator();
        let objWhere = objCreator.getSearchCondition(searchParam);

        let paymentParamsObj = {
            "RequestedPage": 1,
            "PageSize": 10,
            InvoiceWhere: { "OperationList": objWhere.toJsonString() },
            IsFullSearch: false
        }

        const locationConfig = {
            API: {
                'graphql_endpoint': financialPeriodAppSyncUrl,
                graphql_headers: async () => {
                    const currentSession = await Auth.currentSession();
                    return {
                        'Authorization': currentSession.getIdToken().getJwtToken(),
                        'language': languageCode,
                        'x-api-key': financialPeriodApiKey
                    };
                }
            }
        }

        Amplify.configure(locationConfig);

        return await API.graphql(graphqlOperation(getClosingPeriodPage, { data: paymentParamsObj }));
    } catch (error) {
        console.log('getBranch error', error);
    }
}

export {
    getClosingPeriod,
}